import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7350aeea")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-mr-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-3 p-text-bold" }, "Filter by status", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = ["innerHTML"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomShiftsFilters = _resolveComponent("CustomShiftsFilters")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DateFormatted = _resolveComponent("DateFormatted")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Chip = _resolveComponent("Chip")!
  const _component_AppTable = _resolveComponent("AppTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("h1", null, _toDisplayString(_ctx.$t('app_shift.list.title')), 1)
    ]),
    _createVNode(_component_CustomShiftsFilters, {
      filters: _ctx.advFilters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.advFilters = $event)),
      onChange: _ctx.onFiltersChange
    }, null, 8, ["filters", "onChange"]),
    _createVNode(_component_AppTable, {
      ref: "dataTable",
      "striped-rows": false,
      filtersSchema: _ctx.filters,
      service: _ctx.service,
      stateKey: _ctx.stateKey,
      sortField: `created_at`,
      sortOrder: -1,
      onRowClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goToDetail($event.data))),
      onEdit: _ctx.goToDetail,
      onResetFilters: _ctx.onReset
    }, {
      actions: _withCtx(({data}) => [
        _createElementVNode("span", _hoisted_2, [
          _withDirectives(_createVNode(_component_Button, {
            class: "p-button-danger",
            icon: "pi pi-trash",
            onClick: _withModifiers(($event: any) => (_ctx.onDelete(data)), ["stop"])
          }, null, 8, ["onClick"]), [
            [
              _directive_tooltip,
              _ctx.$t('delete'),
              void 0,
              { bottom: true }
            ]
          ])
        ])
      ]),
      columns: _withCtx(({onApplyFilter}) => [
        _createVNode(_component_Column, { header: "ID" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.id), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Created at",
          style: {"min-width":"8rem"}
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_DateFormatted, {
              date: data.created_at,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Status",
          field: "status",
          showFilterMatchModes: false,
          showFilterOperator: false
        }, {
          filter: _withCtx(({filterModel}) => [
            _hoisted_3,
            _createVNode(_component_MultiSelect, {
              modelValue: filterModel.value,
              "onUpdate:modelValue": ($event: any) => (filterModel.value = $event),
              options: _ctx.statusOptions,
              placeholder: "Select statuses",
              optionLabel: "label",
              "option-value": "value"
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
          ]),
          filterclear: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "clear",
              class: "p-button-outlined",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          filterapply: _withCtx(({filterCallback}) => [
            _createVNode(_component_Button, {
              label: "apply",
              onClick: ($event: any) => (onApplyFilter(filterCallback))
            }, null, 8, ["onClick"])
          ]),
          body: _withCtx(({data}) => [
            _createVNode(_component_Chip, _mergeProps({
              label: _ctx.$t('app_shift.statuses.' + _ctx.appShiftStatusEnum[data.status]),
              class: ["p-text-nowrap custom-chip", _ctx.statusBadgeColor(data.status)]
            }, _ctx.$attrs), null, 16, ["label", "class"])
          ]),
          _: 2
        }, 1024),
        _createVNode(_component_Column, { header: "Driver" }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.user.fullname), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "start_datetime",
          header: "Start At",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.start_datetime,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "end_datetime",
          header: "End At",
          sortable: true,
          style: {"min-width":"12rem"}
        }, {
          body: _withCtx(({data}) => [
            _createVNode(_component_DateFormatted, {
              date: data.end_datetime,
              format: "YYYY-MM-DD hh:mm A"
            }, null, 8, ["date"])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "w3load",
          header: "Load Site"
        }, {
          body: _withCtx(({data}) => [
            (data.is_use_load_w3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_4, _toDisplayString(data.w3load), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: _ctx.getAddress(data, 'load')
                }, null, 8, _hoisted_5))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "w3dump",
          header: "Dump Site"
        }, {
          body: _withCtx(({data}) => [
            (data.is_use_dump_w3)
              ? (_openBlock(), _createElementBlock("i", _hoisted_6, _toDisplayString(data.w3dump), 1))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  innerHTML: _ctx.getAddress(data, 'dump')
                }, null, 8, _hoisted_7))
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          field: "job_site",
          header: "Job Site"
        }, {
          body: _withCtx(({data}) => [
            _createTextVNode(_toDisplayString(data.job_site), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["filtersSchema", "service", "stateKey", "onEdit", "onResetFilters"])
  ]))
}